import { ColorPresets } from '@/types/whiteboard';
import { Tool } from './Tool';

export class ShapeTool extends Tool {
  public static SHAPE_TYPE = {
    RECT: 'rect',
    RECT_FILL: 'rect-fill',
    ELLIPSE: 'ellipse',
    ELLIPSE_FILL: 'ellipse-fill',
    LINE: 'line',
    LINE_ARROW: 'line-arrow',
  };

  public static SHAPE_TYPE_ICON = {
    [ShapeTool.SHAPE_TYPE.RECT]: 'icon-square1',
    [ShapeTool.SHAPE_TYPE.RECT_FILL]: {
      normal: 'icon-a-1',
      highlight: 'icon-a-3',
    },
    [ShapeTool.SHAPE_TYPE.ELLIPSE]: 'icon-circle',
    [ShapeTool.SHAPE_TYPE.ELLIPSE_FILL]: {
      normal: 'icon-a-2',
      highlight: 'icon-a-4',
    },
    [ShapeTool.SHAPE_TYPE.LINE]: 'icon-line1',
    [ShapeTool.SHAPE_TYPE.LINE_ARROW]: 'icon-arrow',
  };

  public title = 'TOOLBAR_SHAPE';

  public icon = ShapeTool.SHAPE_TYPE_ICON[ShapeTool.SHAPE_TYPE.RECT] as string;

  public type = ShapeTool.SHAPE_TYPE.RECT;

  public color = ColorPresets.BLACK;

  public setAttributes(options: Partial<{ type: string; color: ColorPresets }>) {
    this.type = options.type ?? this.type;
    this.color = options.color ?? this.color;
    const temp = ShapeTool.SHAPE_TYPE_ICON[this.type];
    this.icon = typeof temp === 'string' ? temp : temp.normal;
  }

  public serialize() {
    return JSON.stringify({ type: this.type, color: this.color });
  }
}

export const shapeTool = new ShapeTool();
